module.exports = "/assets/site/images/katona_kolos.jpeg?c348c36e5546d8d965833442e3b3ad5e";